(function () {
  'use strict';
  if (window.__fizzyCaffeineInfo) return;
  window.__fizzyCaffeineInfo = true;
  var trigger = null;
  var previousOverflow = '';
  var activeDialog = null;

  function close() {
    if (activeDialog && activeDialog.open) window.fizzyPopupMotion.close(activeDialog);
  }

  function open(button) {
    var dialog = document.getElementById('fizzyCaffeineDialog');
    if (!dialog || dialog.open) return;
    trigger = button;
    previousOverflow = document.body.style.overflow;
    activeDialog = dialog;
    if (!dialog.dataset.bound) {
      dialog.dataset.bound = 'true';
      dialog.addEventListener('close', function () {
        document.body.style.overflow = previousOverflow;
        activeDialog = null;
        if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && !event.target.closest('.fcaf-content')) {
          var r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
        }
      });
    }
    window.fizzyPopupMotion.open(dialog);
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-caffeine-open]');
    if (button) { event.preventDefault(); open(button); }
    if (event.target.closest('[data-caffeine-close]')) close();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (activeDialog && event.target.contains(activeDialog)) close();
  });
})();
